import React, { useState, useEffect, Fragment } from 'react';
import {useDispatch } from 'react-redux';
import { Grid, Typography, Divider } from '@material-ui/core';
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import { invokePostService, invokeGetService, setInnerScreenRender } from "../../../store/global/actions";



export default function DeleteRoutingRule(props) {

    // console.log({props})

    const { rrdefId, onClose, onCompletion } = props

    const dispatch = useDispatch();
    // const [rrdefs] = useSelector(getRoutingRules);
    const [rrdef, setRrdef] = useState(null)

    useEffect(() => {

        dispatch(invokeGetService('getAllRrdefs', []))
            .then(response => {
                if (response.data != undefined) {
                    setRrdef(response.data.find(item => item._id == rrdefId))
                }

            })
            .catch(error => console.error(error));


    }, [rrdefId])


    const onDelete = () => {
        // dispatch(deleteNodeAndAssociates({ node: rrdef }));
        dispatch(invokePostService('deleteRrdef', {}, [rrdefId]))
            .then(response => {
                if (response.status) {
                    dispatch(setInnerScreenRender())
                    onCompletion('Routing rule', 'delete')
                }

            })
            .catch(error => console.error(error));

    }

    return (
        <>
            <Grid container>
                <Grid item xs={12} style={{ marginBottom: 10 }} >
                    <Typography variant="h6">Delete</Typography>
                </Grid>
                <Grid item xs={12} >
                    <Divider />
                </Grid>
                <Grid xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Fragment>
                        <Typography> Are you sure you want to delete the Routing Rule {rrdef?.name ? rrdef?.name : ''} ? </Typography>
                    </Fragment>
                </Grid>
                <Grid item xs={12} >
                    <Divider />
                </Grid>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }} >
                    <DeleteCancel onCancel={onClose} onDelete={onDelete} />
                </Grid>
            </Grid>

        </>

    )
}
